import React, { useState } from "react";
import { Link } from "react-router-dom";
import { formatCurrency } from "../../UI/DesignStandards";
import { isoToday, yearBoard } from "../../../utility/organizationYear";
import { listDateLabel } from "../../../utility/squadSpan";

const dateLabel = (tournament, today) =>
  listDateLabel(
    tournament.hasSquads
      ? { squadDates: [tournament.start, tournament.end].filter(Boolean) }
      : { startDate: tournament.start || tournament.startDate },
    today
  );

const paymentLabel = (tournament) => {
  const parts = [];
  if (tournament.paidCount > 0) parts.push(`${tournament.paidCount} paid`);
  if (tournament.dueAtDesk > 0) {
    parts.push(`Due ${formatCurrency(tournament.dueAtDesk)}`);
  } else if (tournament.dueCount > 0) {
    parts.push(`${tournament.dueCount} due`);
  }
  if (tournament.waitlistCount > 0) {
    parts.push(`Waitlist ${tournament.waitlistCount}`);
  }
  return parts.join(" · ");
};

const entryLabel = (tournament) => {
  const online = Number(tournament.entries) || 0;
  const walkUp = Number(tournament.walkUpEntries) || 0;
  const total = online + walkUp;
  if (walkUp > 0) {
    return `${total} entries · ${online} online · ${walkUp} walk-up`;
  }
  return `${total} entries`;
};

const TournamentRow = ({ tournament, today }) => {
  const payment = paymentLabel(tournament);
  const when = dateLabel(tournament, today);
  const detail = [when, entryLabel(tournament), payment]
    .filter(Boolean)
    .join(" · ");

  return (
    <Link
      to={tournament.href}
      className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between min-h-11 px-4 py-3 border-b border-brand-charcoal/10 last:border-b-0 text-brand-charcoal"
    >
      <span className="min-w-0 break-words">
        <span className="font-medium">{tournament.name}</span>
        <span className="block text-sm text-brand-muted">{detail}</span>
      </span>
      <span className="text-sm font-display font-bold shrink-0">
        {tournament.listStatus}
      </span>
    </Link>
  );
};

const YearTournamentBoard = ({ tournaments, year, loading }) => {
  const [today] = useState(isoToday);
  if (loading) return null;
  if (!tournaments?.length) {
    return (
      <p className="text-sm text-brand-muted">
        No tournaments in {year} yet.
      </p>
    );
  }

  const board = yearBoard(tournaments, today);

  return (
    <div className="space-y-4">
      {board.current.length > 0 ? (
        <div className="card-board overflow-hidden">
          <h2 className="px-4 py-3 text-sm text-brand-muted border-b border-brand-charcoal/10">
            Upcoming
          </h2>
          {board.current.map((tournament) => (
            <TournamentRow key={tournament.id} tournament={tournament} today={today} />
          ))}
        </div>
      ) : null}

      {board.past.length > 0 ? (
        <details className="card-board overflow-hidden">
          <summary className="px-4 py-3 min-h-11 text-sm text-brand-muted cursor-pointer">
            Past ({board.past.length})
          </summary>
          {board.past.map((tournament) => (
            <TournamentRow key={tournament.id} tournament={tournament} today={today} />
          ))}
        </details>
      ) : null}
    </div>
  );
};

export default YearTournamentBoard;
